var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resultsWrapper"},[_c('h5',[_vm._v("Current page: "+_vm._s(_vm.page))]),_c('h5',[_vm._v("Pages: "+_vm._s(_vm.maxPage))]),_c('h5',[_vm._v("Results: "+_vm._s(_vm.results))])])}
var staticRenderFns = []

export { render, staticRenderFns }